import { Injectable } from '@angular/core';
import { ApiErrorResponse } from '../../../Interfaces/api/shared/response.interface';

@Injectable({
  providedIn: 'root',
})
export class ApiMessageService {
  resolve(key: string | null | undefined): string | null {
    if (!key) {
      return null;
    }

    return this._isTranslationKey(key) ? key : null;
  }

  fromEnvelope(body: unknown): string | null {
    const envelope = body as ApiErrorResponse | null;

    return this.resolve(envelope?.message);
  }

  validationSummary(body: unknown): string | null {
    const envelope = body as ApiErrorResponse | null;
    const fields = Object.values(envelope?.errors ?? {}).flat();

    return fields.length > 0 ? fields.join(' ') : null;
  }

  private _isTranslationKey(value: string): boolean {
    return /^(app|onboarding|backoffice|shared)(\.[A-Za-z0-9_-]+)+$/.test(value);
  }
}
